<template>
    <div class="base-input">
        <input :type="type" :placeholder="placeholder" @change="change()" :disabled="disabled" v-model="inputValue" />
        <div v-if="clearable && inputValue" @click="clear()">
          <icon class="close-icon" 
                name="close-x" 
                width="18px" 
                height="18px" 
                fill="var(--lighten-7-color)"/>
        </div>
        <div class="icon">
          <slot></slot>
        </div>
    </div>
</template>

<script>

    export default {
        name: "base-input",
        data() {
            return {
                inputValue: ""
            }
        },
        props: {
            type: {
                type: String,
                default: "text"
            },
            value: {
                type: [String, Number, Array],
            },
            placeholder: {
                type: String,
            },
            lazy: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.inputValue = this.value;
        },
        methods: {
            change() {
                if (this.lazy) {
                    this.$emit("input", this.inputValue)
                }
            },
            clear() {
              this.inputValue = "";
            }
        },
        watch: {
            value(val) {
                this.inputValue = val
            },
            inputValue(val) {
                if (!this.lazy) {
                    this.$emit("input", val)
                }
            }
        }
    }
</script>

<style scoped>
    .base-input {
        position: relative;
        width: 100%;
    }

    .base-input input {
        width: 100%;
        box-sizing: border-box;
        border: none;
        outline: none;
        padding: 12px 58px 12px 12px;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
        cursor: pointer;
    }

    .base-input .icon {
        display: flex;
        position: absolute;
        top: 50%;
        right: 6px;
        transform: translateY(-50%)
    }

    .base-input input:focus {
        border: 2px solid var(--primary-color);
        padding: 10px 58px 10px 10px;
        background-color: var(--white-color);
    }

    .base-input .drop-icon {
        position: absolute;
        top: calc(50% - 2px);
        right: 11px;
        transition: all .2s;
    }

    .base-input .close-icon {
      display: flex;
      position: absolute;
      top: 50%;
      right: 40px;
      transform: translateY(-50%);
      cursor: pointer;
    }

   .base-input .close-icon :hover {
      fill: var(--lighten-5-color);
      transition: all .2s;
    }
</style>
